import AppLayout from "../../components/AppLayout";
import TableIntents from "../../components/tables/TableIntents";
import useIntents from "../../hooks/pages/useIntents";
import AlertMsg from "../../components/info/AlertMsg";
import CardContainer from "../../components/cards/CardContainer";

function Intents() {
  document.title = "Intenciones Entrenamiento Avanzado | Trini Talkbot";
  const { isLoading, intents, reloadTable } = useIntents();
  return (
    <AppLayout
      isLoading={isLoading}
      title="Entrenamiento Avanzado"
      subtitle=""
      tab={2}
      tabType="advanced"
      dangerAlert
      warningAlert
    >
      <CardContainer
        softTitle={"INTENCIONES"}
        mainTitle={"Listado de intenciones"}
        description={"Aquí puedes ver todas las intenciones que has creado para tu chatbot. Recuerda que las intenciones son fundamentales para que tu chatbot pueda entender y responder a las consultas de los usuarios de manera efectiva."}
        alerts={intents && intents.length < 2 ? [{
            type: "danger",
            message: "Para el correcto funcionamiento del chatbot, se recomienda tener al menos dos intenciones con no menos de 15 ejemplos cargados."
          }] : []}
      >
        <div className="m-4">
          <TableIntents intents={intents} reloadTable={reloadTable} />
        </div>
      </CardContainer>
    </AppLayout>
  );
}

export default Intents;
